
import { StockIn } from "@/models/base";
import { BookYearService } from "@/services/book-year-service";
import { ProductService } from "@/services/product-service";
import { StockService } from "@/services/stock-service";
import { SupplierService } from "@/services/supplier-service";
import { ScannerListener } from "@/utils/scanner";
import Vue from "vue";
import AppStockEditDesktop from "./StockEditDesktop.vue";
import AppStockEditMobile from "./StockEditMobile.vue";

export default Vue.extend({
	data() {
		return {
			selectedRow: new StockIn(),
			stocks: [] as StockIn[],
			isSaving: false
		};
	},
	props: {
		ids: {
			type: Array as () => number[],
			required: false,
			default: () => []
		}
	},
	watch: {
		ids: {
			immediate: true,
			handler() {
				this.fetch();
			}
		}
	},
	methods: {
		onAddRow(row: StockIn) {
			let date = row.DateCreated;
			if(row.ID){
				date = new Date();
			}
			this.selectedRow = new StockIn();
			this.selectedRow.DateCreated = date;
			if (this.stocks.indexOf(row) == -1) {
				this.stocks.push(row);
			}
		},
		onEditRow(row:StockIn) {
			this.selectedRow = row;
		},
		onRemove(row: StockIn) {
			let index = this.stocks.indexOf(row);
			this.stocks.splice(index, 1);
			if (this.selectedRow == row) {
				this.selectedRow = new StockIn();
			}
		},
		async save() {
			if (this.isSaving) return;
			this.isSaving = true;
			try{
				let deleteStocks = this.stocks.filter(s => s.ID !== 0);
				if (deleteStocks.length){
					await StockService.delStock(deleteStocks);
				}

				deleteStocks.forEach(s => s.ID = 0);
				let result = await StockService.saveStock(this.stocks);
				this.ids.splice(0, this.ids.length);
				this.ids.push(...result.map(s => s.ID));
				this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
				this.$emit("cancel");
			}catch(err){

			}finally{
				this.isSaving = false;
			}
		},
		async fetch() {
			if (this.ids.length > 0) {
				this.stocks = await StockService.getStocksByIds(this.ids);
			}
		},
		async cancel() {
			this.$emit("cancel");
		},
		async onScan(code:string){
			let product = await ProductService.findBySku(code);
			if (!product) {
				this.$wf.notify(this.$ct("product-not-found"), "danger", 3000, "exclamation-triangle");
				return;
			}
			for (let stock of this.stocks) {
				if (stock.ProductID == product.ID){
					stock.Qty++;
					return;
				}
			}
			let stock = new StockIn();
			stock.BookYear = BookYearService.selectedBookYear;
			stock.Supplier = null;
			stock.UnitBuyPrice = product.BuyCatalogPrice || 0.0;
			if (product.Suppliers.length) {
				let m = product.Suppliers.filter(s => s.IsMainSupplier );
				if (m[0].ContactID > 0) {
					stock.Supplier = await SupplierService.getContact(m[0].ContactID);
					stock.SupplierID = stock.Supplier.ID;
				}
				stock.UnitBuyPrice = m[0].NettoPrice;
			}
			stock.Product = product;
			this.stocks.push(stock);
		}
	},
	async mounted() {
		this.fetch();
	},
	created(){
		ScannerListener.onInput(this.onScan);
	},
	destroyed(){
		ScannerListener.offInput(this.onScan);
	},
	components: {
		AppStockEditDesktop,
		AppStockEditMobile
	},
	i18nEx: {
		componentPrefix: "components.stock"
	}
});
